module.exports = __webpack_public_path__ + "static/media/logo.707f554a.png";